export default __webpack_public_path__ + "static/media/breadcrumbs-arrow.aa5b4866.svg";